var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "80px",
    width: "80px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.53 392.53",
    xmlSpace: "preserve",
    fill: "#000000",
    transform: "rotate(180)",
    stroke: "#000000",
    strokeWidth: 0.00392533,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.785066
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M82.554,185.341c5.495-57.923,54.432-103.37,113.713-103.37c31.16,0,59.41,12.606,80.162,32.905 l46.222-38.723c-24.954-26.246-57.859-44.735-94.836-51.459v13.834c0,6.012-4.848,10.925-10.925,10.925 c-6.012,0-10.925-4.848-10.925-10.925V22.044c-3.232-0.129-6.4-0.323-9.632-0.323c-3.232,0-6.465,0.065-9.632,0.323v31.741 c0,6.012-4.848,10.925-10.925,10.925c-6.012,0-10.925-4.848-10.925-10.925V24.63C87.014,38.853,27.152,104.792,22.109,185.277 h60.444V185.341z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M185.341,370.36v-60.251c-54.303-5.172-97.681-48.549-102.853-102.853H22.174 C27.604,294.723,97.81,364.929,185.341,370.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M207.192,310.044v60.251c39.887-2.457,76.218-18.36,104.404-43.378l-42.602-42.602 C251.798,298.602,230.529,307.846,207.192,310.044z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E57373"
    },
    d: "M336.614,92.703l-46.222,38.788c12.735,18.36,20.17,40.727,20.17,64.776 c0,27.604-9.826,52.945-26.182,72.727l42.602,42.602c27.216-30.772,43.766-71.176,43.766-115.265 C370.747,157.543,358.012,121.729,336.614,92.703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffff"
    },
    d: "M196.267,0C87.984,0,0,87.984,0,196.267s87.984,196.267,196.267,196.267 s196.267-87.984,196.267-196.267S304.549,0,196.267,0z M164.719,24.695v29.156c0,6.012,4.848,10.925,10.925,10.925 c6.012,0,10.925-4.848,10.925-10.925V22.109c3.232-0.129,6.4-0.323,9.632-0.323c3.232,0,6.465,0.065,9.632,0.323v16.42 c0,6.012,4.848,10.925,10.925,10.925c6.012,0,10.925-4.848,10.925-10.925V24.695c36.913,6.788,69.883,25.212,94.707,51.394 l-46.222,38.723c-20.493-20.299-48.743-32.905-79.903-32.905c-59.345,0-108.283,45.511-113.713,103.37h-60.38 C27.216,104.857,87.079,38.917,164.719,24.695z M103.758,196.267c0-51.006,41.503-92.509,92.509-92.509s92.509,41.503,92.509,92.509 s-41.503,92.509-92.509,92.509S103.758,247.273,103.758,196.267z M82.554,207.192c5.172,54.303,48.55,97.681,102.853,102.853v60.251 c-87.531-5.43-157.802-75.636-163.232-163.232h60.38V207.192z M207.192,370.36v-60.251c23.337-2.263,44.671-11.442,61.802-25.665 l42.602,42.602C283.345,352,247.143,367.903,207.192,370.36z M284.444,268.994c16.356-19.782,26.182-45.123,26.182-72.727 c0-24.048-7.499-46.287-20.17-64.776l46.222-38.788c21.398,29.026,34.133,64.776,34.133,103.564 c0,44.218-16.549,84.558-43.766,115.265L284.444,268.994z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.a06105493a07e4e64a82d65b6b7abea3.svg";
export { ForwardRef as ReactComponent };